export default function (Component) {
Component.options.__tip = "<p>If you modify the <code>items</code>-array, make sure that the modification is done in a way compatible with <a href=\"https://vuejs.org/v2/guide/reactivity.html\">Vue&#39;s reactivity system</a>.</p>\n"
}